/**
 * Plotzio component primitives — the M1 reference library.
 * Every later UI milestone (M3–M12) composes ONLY from these + the token
 * contract (DESIGN_SYSTEM.md). Styles live in ./primitives.css (imported
 * globally by src/app/layout.tsx).
 */
export {
  Button,
  IconButton,
  ButtonLink,
  buttonClasses,
  type ButtonProps,
  type ButtonLinkProps,
  type ButtonVariant,
  type ButtonSize,
  type ButtonShape,
} from "./button";
export { UpgradeButton, type UpgradeButtonProps } from "./upgrade-button";
export { Input, type InputProps } from "./input";
export { Textarea, type TextareaProps } from "./textarea";
export { Select, type SelectProps } from "./select";
export { Checkbox, Radio, type CheckboxProps } from "./checkbox";
export { Toggle, type ToggleProps } from "./toggle";
export { Label, Field, type LabelProps, type FieldProps } from "./field";
export { Card, CardHeader, CardTitle, CardBody, CardFooter, type CardProps } from "./card";
export { Modal, type ModalProps } from "./modal";
export { Drawer, type DrawerProps } from "./drawer";
export { Popover, type PopoverProps } from "./popover";
export { Tooltip, type TooltipProps } from "./tooltip";
export { Toast, ToastRegion, type ToastProps, type ToastVariant, type ToastAction } from "./toast";
export { Tabs, type TabsProps, type TabItem } from "./tabs";
export { Table, NumCell, Row } from "./table";
export { ListRows, ListRow } from "./list-row";
export { Badge, AccuracyChip, type BadgeProps, type BadgeVariant, type AccuracyLevel } from "./badge";
export { Progress, Skeleton, type ProgressProps, type SkeletonProps } from "./progress";
export { Spinner, type SpinnerProps } from "./spinner";
// Icon component + the curated Lucide glyph set (the ONLY sanctioned icon source).
export * from "./icon";
export { Wordmark, type WordmarkProps } from "./wordmark";
export { AppShell, Topbar, ShellMain, type TopbarProps } from "./app-shell";
export { EmptyState, type EmptyStateProps } from "./empty-state";
export { SegmentedControl, type SegmentedControlProps, type SegmentedOption } from "./segmented";
export { Slider, type SliderProps } from "./slider";
export { Swatch, Legend, RampStrip, type SwatchProps, type LegendProps, type RampStripProps } from "./swatch";
export { EmbedSnippet, type EmbedSnippetProps } from "./embed-snippet";
export { Avatar, type AvatarProps } from "./avatar";
export { ChatBubble, type ChatBubbleProps } from "./chat-bubble";
export { UpsellModal, type UpsellModalProps, type UpsellPrice } from "./upsell-modal";
export { Paywall, type PaywallProps, type PaywallCopyVariant } from "./paywall";
export { QuotaWarning, type QuotaWarningProps } from "./quota-warning";
export { ProUpsellModal, type ProUpsellModalProps } from "./pro-upsell-modal";
export {
  ProModalProvider,
  useProUpsell,
  type ProModalProviderProps,
  type OpenProUpsellOptions,
  type ProUpsellContextValue,
} from "./pro-modal-provider";
export { FrozenMapNotice, type FrozenMapNoticeProps } from "./frozen-map-notice";
export { ControlBar, ControlGroup } from "./control-bar";
export { LockedFeature, type LockedFeatureProps } from "./locked-feature";
export { AskBar } from "./ask-bar";
export { Stack, type StackGap } from "./stack";
export { cx } from "./cx";
